// extracted by mini-css-extract-plugin
export default {"wrap":"e-z","heading":"f-z","formError":"g-z"};